import routerOptions0 from "/builds/uroweb/uroweb-frontend/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@20.17.50_db0@0.3.2_eslint@8.57.1_ioredis@5.6.1__kpghifj2wkzhw7zgql2gcungoi/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}